import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import { listVersions, restoreVersion } from "../../../api/minisite";

export default function VersionsTab({ clientId, onRestore }) {
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const v = await listVersions(clientId);
        setVersions(v);
      } catch (e) {
        setError(e?.response?.data?.detail || e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [clientId]);

  const handleRestore = async (v) => {
    if (!window.confirm(`Restaurer la version v${v.version_number} ? Le draft actuel sera écrasé.`)) return;
    try {
      await restoreVersion(clientId, v.version_id);
      toast.success(`Version v${v.version_number} restaurée`);
      onRestore && onRestore();
    } catch (e) {
      toast.error("Échec restore : " + (e?.response?.data?.detail || e.message));
    }
  };

  if (loading) return <div>Chargement...</div>;
  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (versions.length === 0) return <div>Aucune version publiée pour l'instant.</div>;

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ borderBottom: "2px solid #ccc" }}>
          <th style={{ textAlign: "left", padding: 8 }}>Version</th>
          <th style={{ textAlign: "left", padding: 8 }}>Publié le</th>
          <th style={{ textAlign: "left", padding: 8 }}>Par</th>
          <th style={{ textAlign: "left", padding: 8 }}>URL</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {versions.map((v) => (
          <tr key={v.version_id} style={{ borderBottom: "1px solid #eee" }}>
            <td style={{ padding: 8 }}>v{v.version_number}</td>
            <td style={{ padding: 8 }}>{v.published_at}</td>
            <td style={{ padding: 8 }}>{v.published_by}</td>
            <td style={{ padding: 8 }}>
              {v.live_url && (
                <a href={v.live_url} target="_blank" rel="noreferrer">Voir</a>
              )}
            </td>
            <td>
              <button onClick={() => handleRestore(v)}>Restaurer</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
